var path = '/ui/details/details-record-html.html';
var html = "<div class=\"rv-details-html template-mount\" ng-if=\"self.details.template\" ng-show=\"self.item.data[0]\"></div>\n<div class=\"rv-details-text\" ng-bind-html=\"self.item.data[0]\" ng-if=\"!self.details.template\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;